import React from "react"
import Modal from 'react-bootstrap/Modal'
import { useRoster } from '../StudentsContext';
import { Button, Col, Row } from 'react-bootstrap';
import { ModalType } from "../Import";

interface IEPProps {
    setModalType: (modalType: ModalType) => void
}

export default function IEPForm({ setModalType }: IEPProps) {
    return <>
        <Modal.Body className="g-3">
            <Row>
                <h3>IEP Allowed Values</h3>
            </Row>

            <Row>
                <p>Yes</p>
                <p>No</p>
                <p>Decline to Answer</p>
            </Row>

            <Row>
                <Col>
                    <Button onClick={() => setModalType("default")}>Return to Import</Button>
                </Col>
            </Row>
        </Modal.Body>
    </>
}
